import { render } from "./ExpenseList.vue?vue&type=template&id=0aba598c&scoped=true"
import script from "./ExpenseList.vue?vue&type=script&lang=js"
export * from "./ExpenseList.vue?vue&type=script&lang=js"

import "./ExpenseList.vue?vue&type=style&index=0&id=0aba598c&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aba598c"]])

export default __exports__